import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { obtenerArticulos } from '../../services/articuloService';
import './Blog.css';

const Blog = () => {
  const navigate = useNavigate();
  const [articulos, setArticulos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categoria, setCategoria] = useState('todos');

  useEffect(() => {
    cargarArticulos();
  }, []);

  const cargarArticulos = async () => {
    try {
      setLoading(true);
      const data = await obtenerArticulos();
      setArticulos(data);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const categorias = ['todos', 'Ley 1480', 'Traspasos', 'RUNT', 'SIMIT', 'Embargos'];

  const articulosFiltrados = categoria === 'todos' 
    ? articulos 
    : articulos.filter(a => a.categoria === categoria);

  const formatearFecha = (fecha) => {
    if (!fecha) return 'Fecha no disponible';
    return fecha.toLocaleDateString('es-CO', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  if (loading) return <div className="loading">Cargando artículos...</div>;

  return (
    <div className="blog-container">
      <div className="blog-header">
        <button className="btn-volver-inicio" onClick={() => navigate('/')}>
          ← Volver al Inicio
        </button>
        <h1>Blog Legal</h1>
        <p>Artículos y consejos sobre derecho automotor</p>
      </div>

      <div className="blog-filters">
        <span>Filtrar por categoría:</span>
        <div className="filters-buttons">
          {categorias.map(cat => (
            <button
              key={cat}
              className={`filter-btn ${categoria === cat ? 'active' : ''}`}
              onClick={() => setCategoria(cat)}
            >
              {cat === 'todos' ? 'Todos' : cat}
            </button>
          ))}
        </div>
      </div>

      {articulosFiltrados.length === 0 ? (
        <div className="sin-articulos">
          <p>No hay artículos en esta categoría</p>
        </div>
      ) : (
        <div className="articulos-grid">
          {articulosFiltrados.map(articulo => (
            <article key={articulo.id} className="articulo-card">
              <div className="articulo-categoria">{articulo.categoria}</div>
              <h2>{articulo.titulo}</h2>
              <div className="articulo-meta">
                <span>{formatearFecha(articulo.fechaPublicacion)}</span>
                <span>{articulo.vistas || 0} vistas</span>
              </div>
              <p className="articulo-resumen">{articulo.resumen}</p>
              <Link to={`/blog/${articulo.id}`} className="btn-leer-mas">
                Leer más →
              </Link>
            </article>
          ))}
        </div>
      )}
    </div>
  );
};

export default Blog;